module.exports = __webpack_public_path__ + "media/images/logo-6486ffa5ed9475128cca88ef841e0586.svg";